var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DistintaMultilevel',{staticClass:"ma-5",staticStyle:{"border-radius":"0px"},on:{"go_back":_vm.goBack}})}
var staticRenderFns = []

export { render, staticRenderFns }